<template>
  <section class="content--sinoreg ">
    <header class="headerBlue">
      <h4 class="resumo-show_title pl-2 mt-3">
        <span class="pt-3 resumo-show_title-label">
          Mensalistas - Serviçoes Realizados
        </span>
      </h4>
    </header>
    <div>
      <OrdemServicoMensalista @addMensalista="setMensalista" />
    </div>
    <FiltroDataMensalista class="ml-3"
                          :prop-id-mensalista="mensalista"
                          @getServicosRealizados="gerarRelatorioPDF" />
    <div class="col text-right mt-3">
      <b-button v-if="urlPdf"
                @click="openUrl()">
        <icon-svg icon="print"
                  class="icon--xs icons--white" />
        Imprimir
      </b-button>
      <b-button v-if="urlPdf"
                class="ml-3"
                @click="exportExcel">
        <icon-svg icon="fileDownload"
                  class="icon--xs icons--white" />
        Exportar
      </b-button>
    </div>
    <div class="col">
      <object v-if="urlPdf != null"
              class="document-preview embed-responsive Relatorios--pdf"
              :data="urlPdf"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>
    </div>
  </section>
</template>

<script>
  // Componentes
  import OrdemServicoMensalista from '../OrdemServicoMensalista/OrdemServicoMensalista.vue'
  import FiltroDataMensalista from '../Filtros/FiltroDataMensalista.vue'

  // Services
  import MensalistaService from '../mensalistaService'
  import CartorioService from "@/services/CartorioService"

  /* others */
  import { mapGetters } from "vuex"
  import moment from 'moment'

  export default ({
    name: 'ServicosRealizados',
    components: {
      OrdemServicoMensalista,
      FiltroDataMensalista
    },
    data () {
      return {
        mensalista: null,
        urlPdf: null,
        cartorioId: null,
        cartorio: {},
        dataDaVez: '',
        pedidosDia: {
          pendentes: {
            list: [],
            valorTotal: 0
          },
          concluidos: {
            list: [],
            valorTotal: 0
          },
          data: '',
          diaExtenso: '',
          valorTotal: 0
        },
        pedidos: {
          arrayPedidosDia: [],
          geral: {
            valorTotal: 0,
            valorConcluidos: 0,
            valorPendentes: 0,
            dataInicial: '',
            dataFinal: '',
            dataGeracao: moment(new Date()).format('DD/MM/YYYY')
          }
        }
      }      
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    async created () {
      const { data } = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
      this.cartorio = data
    }, 
    methods: {
      async setMensalista (mensalista) {
        this.mensalista = mensalista
      },
      async gerarRelatorioPDF (mensalista, infosDatas) {
        this.mensalista = mensalista[0]
        // Verifica se há pedidos do mensalista no período selecionado
        if (this.mensalista.pedidos.length === 0) {
          return displayMessage('error', 'Não há pedidos desse mensalista no período selecionado')
        }
        // Tratamento de datas
        this.dataDaVez = moment(infosDatas.dataInicial, 'YYYY-MM-DD').format('YYYY-MM-DD')
        const dataFinal = moment(infosDatas.dataFinal, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.pedidos.geral.dataInicial = moment(infosDatas.dataInicial, 'YYYY-MM-DD').format('DD/MM/YYYY')
        this.pedidos.geral.dataFinal = moment(dataFinal, 'YYYY-MM-DD').format('DD/MM/YYYY')
        
        // Separa os pedidos do periodo por dia
        while (this.dataDaVez <= dataFinal) {
          // Formata data dos pedidos para validação
          mensalista[0].pedidos.forEach(pedido => pedido.created_at = moment(pedido.created_at, 'YYYY-MM-DD').format('YYYY-MM-DD'))

          // Filtra pedidos por dia e salva
          const data = mensalista[0].pedidos.filter(pedido => pedido.created_at === this.dataDaVez)
          // Caso exista pedidos no dia separa entre concluidos e pendentes
          if (data.length) {
            this.organizaPedidosStatus(data)
            this.calcularValores(data)

            this.pedidos.arrayPedidosDia.push(this.pedidosDia)
            // Reseta variavel para próximo loop
            this.pedidosDia = {
              pendentes: {
                list: [],
                valorTotal: 0
              },
              concluidos: {
                list: [],
                valorTotal: 0
              },
              data: '',
              valorTotal: 0
            } 
          }
          this.dataDaVez = moment(this.dataDaVez, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')          
        }
        // Calcula valor total de pedidos no período
        this.pedidos.geral.valorTotal = this.pedidos.geral.valorConcluidos + this.pedidos.geral.valorPendentes
        const payload = {
          cartorio: this.cartorio,
          mensalista: mensalista,
          pedidos: this.pedidos
        }

        try {
          loader({ text: 'Gerando Relatório', active: true })
          const relatorioPDF = await MensalistaService.getPdfPedidosRealizados(payload)
          this.urlPdf = relatorioPDF
        } catch (err) {
          console.log(err)
        } finally {
          loader({ text: null, active: false })
        }
        this.pedidos = {
          arrayPedidosDia: [],
          geral: {
            qtTotal: 0,
            valorTotal: 0,
            valorConcluidos: 0,
            valorPendentes: 0,
            dataInicial: '',
            dataFinal: '',
            dataGeracao: moment(new Date()).format('DD/MM/YYYY')
          }
        }
      },
      organizaPedidosStatus (data) {
        moment.locale('pt-br')
        data.forEach(pedido => {
          if (pedido.status_pg === 'concluido') this.pedidosDia.concluidos.list.push(pedido)
          if (pedido.status_pg === 'faturado') this.pedidosDia.pendentes.list.push(pedido)
          this.pedidosDia.data = moment(this.dataDaVez, 'YYYY-MM-DD').format('DD/MM/YYYY')
          // Tratar data por extenso
          let dia = moment(this.dataDaVez).format('dddd')
          dia = dia[0].toUpperCase() + dia.substring(1)
          this.pedidosDia.diaExtenso = dia
          //Trata length do selo
          if (pedido.ordemServico.itens.length && pedido.ordemServico.itens[0].seloItemOs.length) {
            pedido.ordemServico.itens[0].seloItemOs[0].selo.num_selo =  pedido.ordemServico.itens[0].seloItemOs[0].selo.num_selo.substring(0, 6) + '...'
          }
        })
      },
      calcularValores () {
        this.pedidosDia.concluidos.list.forEach(pedido => {
          this.pedidosDia.concluidos.valorTotal += pedido.ordemServico.valor_total
          this.pedidos.geral.valorConcluidos += pedido.ordemServico.valor_total
        })
        this.pedidosDia.pendentes.list.forEach(pedido => {
          this.pedidosDia.pendentes.valorTotal += pedido.ordemServico.valor_total
          this.pedidos.geral.valorPendentes += pedido.ordemServico.valor_total
        })
        this.pedidosDia.valorTotal = this.pedidosDia.concluidos.valorTotal + this.pedidosDia.pendentes.valorTotal
      },
      openUrl () {
        window.open(this.urlPdf)
      },
      async exportExcel () {
        try {
          const resExcel = await MensalistaService.exportExcelRelatorio(this.mensalista)
          const blob = new Blob([resExcel.data], {type: resExcel.headers['content-type']})
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', `pedidos-${this.mensalista.nome_empresa}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

        } catch (err) {
          console.log('ServicosRealizados', err)
        } finally {

        }
        // try {
        //   loader({text: 'Exportando em excel', active: true})
        //   this.$validator.validate().then(async resp => {
        //     if (resp) {
        //       moment.locale('pt-br')

        //       const resExcel = await RelatorioCustaService.exportExcelRelatorio({...this.busca, cartorio: this.cartorio})

        //       const blob = new Blob([resExcel.data], {type: resExcel.headers['content-type']})
        //       const link = document.createElement('a')
        //       link.href = window.URL.createObjectURL(blob)
        //       link.setAttribute('download', `Serviços realizados e recolhidos ${this.busca.tipo} - ` + moment(new Date()).format('LL') + '.xlsx')
        //       document.body.appendChild(link)
        //       link.click()
        //       document.body.removeChild(link)
        //     }
        //   })
        // } finally {
        //   loader({ active: false })
        // }
      }
    },
  })
</script>

<style lang="scss" scoped>
  @import "../../../../../scss/_utilities/_variables";
  .headerBlue{
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    font-size: pxToRem(20);
    font-weight: 500;
    height: 100%;
    width: 100%;
    color: #000;
  }
  .Relatorios {
    &--pdf {
      height: 60vh;
      margin-top: 40px;
    }
  }
</style>
